/* TIS GraphQL Queries */

export const listUserAccessesByUserId = /* GraphQL */ `
  query ListUserAccessesByUserId($userId: ID!) {
    listUserAccessesByUserId(userId: $userId) {
      items {
        id
        userId
        app {
          id
          name
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
